import React, { useState } from "react";
import { Link, useNavigate } from "react-router-dom";
import { useAuth } from "../contexts/AuthContext";
import { toast } from "sonner";

export default function Register() {
  const { register } = useAuth();
  const navigate = useNavigate();
  const [name, setName] = useState("");
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [loading, setLoading] = useState(false);

  const submit = async (e) => {
    e.preventDefault();
    setLoading(true);
    const res = await register(email, password, name);
    setLoading(false);
    if (res.ok) {
      toast.success("Cuenta creada");
      navigate("/app/dashboard");
    } else {
      toast.error(res.error);
    }
  };

  return (
    <div className="min-h-screen grid lg:grid-cols-2" data-testid="register-page">
      <div className="auth-bg hidden lg:flex relative">
        <div className="absolute inset-0 bg-gradient-to-b from-[#1B4332]/30 via-transparent to-[#1B4332]/60" />
        <div className="relative z-10 p-12 flex flex-col justify-between text-white w-full">
          <div className="flex items-center gap-2">
            <div className="h-8 w-8 rounded-sm bg-white text-[#1B4332] flex items-center justify-center font-display font-bold">
              A
            </div>
            <span className="font-display font-semibold tracking-tight text-lg">Aequor</span>
          </div>
          <div className="space-y-3 max-w-md">
            <div className="label-caps text-white/70">Nueva cuenta</div>
            <h2 className="font-display text-4xl font-light leading-tight">
              Empieza a llevar tu contabilidad en minutos.
            </h2>
          </div>
        </div>
      </div>

      <div className="flex items-center justify-center p-8 bg-[#F9F8F6]">
        <form
          onSubmit={submit}
          className="w-full max-w-sm bg-white border border-[#E2DFD8] rounded-md p-8"
          data-testid="register-form"
        >
          <div className="label-caps mb-2">Crear cuenta</div>
          <h1 className="font-display text-2xl font-medium tracking-tight mb-6">Regístrate</h1>

          <label className="label-caps block mb-1.5">Nombre completo</label>
          <input
            type="text"
            required
            data-testid="register-name"
            value={name}
            onChange={(e) => setName(e.target.value)}
            className="w-full px-3 py-2 rounded-sm border border-[#E2DFD8] focus:outline-none focus:ring-2 focus:ring-[#1B4332]/30 text-sm mb-4"
          />

          <label className="label-caps block mb-1.5">Correo</label>
          <input
            type="email"
            required
            data-testid="register-email"
            value={email}
            onChange={(e) => setEmail(e.target.value)}
            className="w-full px-3 py-2 rounded-sm border border-[#E2DFD8] focus:outline-none focus:ring-2 focus:ring-[#1B4332]/30 text-sm mb-4"
          />

          <label className="label-caps block mb-1.5">Contraseña</label>
          <input
            type="password"
            required
            minLength={6}
            data-testid="register-password"
            value={password}
            onChange={(e) => setPassword(e.target.value)}
            className="w-full px-3 py-2 rounded-sm border border-[#E2DFD8] focus:outline-none focus:ring-2 focus:ring-[#1B4332]/30 text-sm mb-6"
          />

          <button
            type="submit"
            disabled={loading}
            data-testid="register-submit"
            className="w-full bg-[#1B4332] hover:bg-[#2D6A4F] disabled:opacity-60 text-white text-sm font-medium py-2.5 rounded-sm transition-colors"
          >
            {loading ? "Creando…" : "Crear cuenta"}
          </button>

          <p className="text-center text-xs text-[#59645E] mt-6">
            ¿Ya tienes cuenta?{" "}
            <Link to="/login" className="text-[#1B4332] font-medium hover:underline" data-testid="register-login-link">
              Inicia sesión
            </Link>
          </p>
        </form>
      </div>
    </div>
  );
}
